import { useState, useEffect } from 'react';
import { findArticleById } from '../data/articles';

function useArticleLoader(articleId) {
  const [article, setArticle] = useState(null);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadArticle = async () => {
      try {
        // Find article metadata
        const articleMeta = findArticleById(articleId);

        if (!articleMeta) {
          throw new Error('Article not found');
        }

        setArticle(articleMeta);

        // Load markdown content
        const response = await fetch(`/articles/${articleMeta.filename}`);
        
        if (!response.ok) {
          throw new Error('Article file not found');
        }

        const text = await response.text();
        
        // Remove frontmatter if present
        const contentWithoutFrontmatter = text.replace(/^---[\s\S]*?---\n/, '');
        setContent(contentWithoutFrontmatter);
        setLoading(false);
      } catch (err) {
        console.error('Error loading article:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    loadArticle();
  }, [articleId]);

  return { article, content, loading, error };
}

export default useArticleLoader;